// extracted by mini-css-extract-plugin
module.exports = {"block":"block___1ZBB-","resourceName":"resourceName___3OZmL","btn":"btn___289aD"};